"use client";

import { useActionState } from "react";

import { login, type LoginState } from "@/app/(auth)/login/actions";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/ui/password-input";
import { t } from "@/lib/i18n";

export function LoginForm({ volgende }: { volgende?: string }) {
  const [state, formAction, pending] = useActionState<LoginState, FormData>(
    login,
    {},
  );

  return (
    <form action={formAction} className="grid gap-4">
      {volgende ? <input type="hidden" name="volgende" value={volgende} /> : null}
      {state.error ? (
        <Alert variant="destructive">
          <AlertDescription>{state.error}</AlertDescription>
        </Alert>
      ) : null}
      <div className="grid gap-2">
        <Label htmlFor="email">{t.auth.email}</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus
          required
          placeholder="naam@bedrijf.nl"
        />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="password">{t.auth.wachtwoord}</Label>
        <PasswordInput
          id="password"
          name="password"
          autoComplete="current-password"
          required
        />
      </div>
      <Button type="submit" disabled={pending} className="w-full">
        {pending ? t.algemeen.bezig : t.auth.inloggen}
      </Button>
    </form>
  );
}
